"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stSuiEventTypes = exports.stSuiEventCategories = void 0;
exports.fetchMultiCategoryStSuiEvents = fetchMultiCategoryStSuiEvents;
exports.putDataToStSuiEventsCacheTable = putDataToStSuiEventsCacheTable;
exports.queryFromStSuiEventsCacheTable = queryFromStSuiEventsCacheTable;
exports.getLastUpdatedTimeFromStSuiEventsCacheTable = getLastUpdatedTimeFromStSuiEventsCacheTable;
exports.updateStSuiEventsCacheTable = updateStSuiEventsCacheTable;
const stsui_sdk_1 = require("@alphafi/stsui-sdk");
const client_dynamodb_1 = require("@aws-sdk/client-dynamodb");
const lib_dynamodb_1 = require("@aws-sdk/lib-dynamodb");
const eventsCache_js_1 = require("./eventsCache.js");
exports.stSuiEventCategories = [
    "MintEvent",
    "RedeemEvent",
    "FlashStakeEvent",
    "EpochChangedEvent",
];
exports.stSuiEventTypes = [
    "0xc35ee7fee75782806890cf8ed8536b52b4ba0ace0fb46b944f1155cc5945baa3::events::Event<0xc35ee7fee75782806890cf8ed8536b52b4ba0ace0fb46b944f1155cc5945baa3::liquid_staking::EpochChangedEvent>",
    "0xc35ee7fee75782806890cf8ed8536b52b4ba0ace0fb46b944f1155cc5945baa3::events::Event<0xc35ee7fee75782806890cf8ed8536b52b4ba0ace0fb46b944f1155cc5945baa3::liquid_staking::FlashStakeEvent>",
    "0xc35ee7fee75782806890cf8ed8536b52b4ba0ace0fb46b944f1155cc5945baa3::events::Event<0xc35ee7fee75782806890cf8ed8536b52b4ba0ace0fb46b944f1155cc5945baa3::liquid_staking::MintEvent>",
    "0xc35ee7fee75782806890cf8ed8536b52b4ba0ace0fb46b944f1155cc5945baa3::events::Event<0xc35ee7fee75782806890cf8ed8536b52b4ba0ace0fb46b944f1155cc5945baa3::liquid_staking::RedeemEvent>",
];
async function fetchMultiCategoryStSuiEvents(params) {
    const result = {};
    const { eventCategories, startTime, endTime } = params;
    const promises = eventCategories.map(async (category) => {
        switch (category) {
            case "MintEvent":
                result["MintEvent"] = await stsui_sdk_1.Events.getMintEvents({
                    startTime,
                    endTime,
                    typeName: (0, stsui_sdk_1.getConf)().STSUI_COIN_TYPE,
                });
                break;
            case "RedeemEvent":
                result["RedeemEvent"] = await stsui_sdk_1.Events.getRedeemEvents({
                    startTime,
                    endTime,
                    typeName: (0, stsui_sdk_1.getConf)().STSUI_COIN_TYPE,
                });
                break;
            case "FlashStakeEvent":
                result["FlashStakeEvent"] = await stsui_sdk_1.Events.getFlashStakeEvents({
                    startTime,
                    endTime,
                    typeName: (0, stsui_sdk_1.getConf)().STSUI_COIN_TYPE,
                });
                break;
            case "EpochChangedEvent":
                result["EpochChangedEvent"] = await stsui_sdk_1.Events.getEpochChangeEvents({
                    startTime,
                    endTime,
                    typeName: (0, stsui_sdk_1.getConf)().STSUI_COIN_TYPE,
                });
                break;
            default:
                return Promise.reject(new Error(`Unsupported event category: ${category}`));
        }
    });
    await Promise.all(promises);
    return result;
}
async function putDataToStSuiEventsCacheTable(events) {
    const tableName = process.env.STSUI_EVENTS_CACHE_TABLE_NAME;
    const ddbClient = process.env.LOCAL_AWS
        ? new client_dynamodb_1.DynamoDBClient({ region: "local", endpoint: "http://localhost:8000" })
        : new client_dynamodb_1.DynamoDBClient({ region: process.env.AWS_REGION });
    const ddbDocClient = lib_dynamodb_1.DynamoDBDocumentClient.from(ddbClient);
    if (!tableName) {
        throw new Error("Table name not found from env");
    }
    try {
        const promises = events.map(async (event) => {
            const thirtyOneDaysInSeconds = 31 * 24 * 60 * 60;
            const ttlInSeconds = Math.floor(Date.now() / 1000) + thirtyOneDaysInSeconds;
            const item = {
                "timestamp#digest#seq": `${event.timestamp}#${event.txDigest}#${event.eventSeq
                    .toString()
                    .padStart(3, "0")}`,
                expiresAt: ttlInSeconds,
                ...event,
                type: event.type,
            };
            const command = new lib_dynamodb_1.PutCommand({
                TableName: tableName,
                Item: item,
            });
            await ddbDocClient.send(command);
        });
        await Promise.all(promises);
    }
    catch (error) {
        console.error("Error writing data to DynamoDB:", error);
    }
}
async function queryFromStSuiEventsCacheTable(filter) {
    const tableName = process.env.STSUI_EVENTS_CACHE_TABLE_NAME;
    const ddbClient = process.env.LOCAL_AWS
        ? new client_dynamodb_1.DynamoDBClient({ region: "local", endpoint: "http://localhost:8000" })
        : new client_dynamodb_1.DynamoDBClient({ region: process.env.AWS_REGION });
    const ddbDocClient = lib_dynamodb_1.DynamoDBDocumentClient.from(ddbClient);
    if (!tableName) {
        throw new Error("Table name not found from env");
    }
    let commandInputs = [];
    if ((0, eventsCache_js_1.isAnd)(filter)) {
        const filters = filter.and;
        let eventTypes = [];
        let timeRange = undefined;
        for (const filter of filters) {
            if ((0, eventsCache_js_1.isTimeRange)(filter)) {
                timeRange = filter.timeRange;
            }
            else if ((0, eventsCache_js_1.isEventTypes)(filter)) {
                eventTypes = [...eventTypes, ...filter.eventTypes];
            }
            else {
                console.warn(`skipping unexpected filter: `, filter);
            }
        }
        commandInputs = eventTypes.map((eventType) => {
            const input = {
                TableName: tableName,
                KeyConditionExpression: "#type = :type AND #time BETWEEN :start AND :end",
                ExpressionAttributeNames: {
                    "#time": "timestamp#digest#seq",
                    "#type": "type",
                },
                ExpressionAttributeValues: {
                    ":type": eventType,
                    ":start": `${timeRange.startTime.toString()}#`,
                    ":end": `${timeRange.endTime.toString()}#~~~~~~`,
                },
            };
            return input;
        });
    }
    else if ((0, eventsCache_js_1.isTimeRange)(filter)) {
        console.log("This timeRange Type filter is not yet implemented");
        // todo --> fetch all the events between these times
    }
    else if ((0, eventsCache_js_1.isEventTypes)(filter)) {
        console.log("This event Type filter is not yet implemented");
        // todo --> fetch all the events of the given types
    }
    else {
        console.warn("event filter did not match, returning empty array");
        return [];
    }
    try {
        const events = (await Promise.all(commandInputs.map((input) => executeStSuiQueryWithPagination(input, ddbDocClient)))).flat();
        return events;
    }
    catch (error) {
        console.error("Error fetching items");
        throw error;
    }
}
async function executeStSuiQueryWithPagination(command, ddbDocClient) {
    let items = [];
    let lastEvaluatedKey;
    do {
        const response = await ddbDocClient.send(new lib_dynamodb_1.QueryCommand({ ...command, ExclusiveStartKey: lastEvaluatedKey }));
        if (response.Items) {
            const parsedItems = response.Items.map((item) => {
                return item;
            });
            items = items.concat(parsedItems);
        }
        lastEvaluatedKey = response.LastEvaluatedKey;
    } while (lastEvaluatedKey);
    return items;
}
async function getLastUpdatedTimeFromStSuiEventsCacheTable() {
    const tableName = process.env.STSUI_EVENTS_CACHE_TABLE_NAME;
    const ddbClient = process.env.LOCAL_AWS
        ? new client_dynamodb_1.DynamoDBClient({ region: "local", endpoint: "http://localhost:8000" })
        : new client_dynamodb_1.DynamoDBClient({ region: process.env.AWS_REGION });
    const ddbDocClient = lib_dynamodb_1.DynamoDBDocumentClient.from(ddbClient);
    if (!tableName) {
        throw new Error("Table name not found from env");
    }
    try {
        const params = {
            TableName: tableName,
            KeyConditionExpression: "#type = :type",
            ExpressionAttributeNames: {
                "#type": "type",
            },
            ExpressionAttributeValues: {
                ":type": `0xc35ee7fee75782806890cf8ed8536b52b4ba0ace0fb46b944f1155cc5945baa3::events::Event<0xc35ee7fee75782806890cf8ed8536b52b4ba0ace0fb46b944f1155cc5945baa3::liquid_staking::MintEvent>`,
            },
            ScanIndexForward: false,
            Limit: 1,
        };
        const response = await ddbDocClient.send(new lib_dynamodb_1.QueryCommand(params));
        const items = response.Items;
        if (items && items.length > 0) {
            const parsedItems = items.map((item) => {
                return item;
            })[0];
            return Number(parsedItems.timestamp);
        }
        else {
            // TODO --> should consider querying for other types if this fails, return 0 if table is empty
            return 0;
        }
    }
    catch (e) {
        console.error("failed to get last updated time");
        throw e;
    }
}
async function updateStSuiEventsCacheTable() {
    try {
        console.time("updateStSuiEventsCacheTable");
        const lastUpdatedTime = await getLastUpdatedTimeFromStSuiEventsCacheTable();
        console.log("stsui last updated time", lastUpdatedTime);
        const now = Date.now();
        const events = await fetchMultiCategoryStSuiEvents({
            eventCategories: exports.stSuiEventCategories,
            startTime: lastUpdatedTime,
            endTime: now,
        });
        const combinedEvents = Object.values(events)
            .flat()
            .map((event) => (0, eventsCache_js_1.convertEventNodeFieldsToBigInt)(event));
        console.log("stsui events fetched", combinedEvents.length);
        await putDataToStSuiEventsCacheTable(combinedEvents);
        console.log("stsui data put to table");
        console.timeEnd("updateStSuiEventsCacheTable");
    }
    catch (err) {
        console.error("failed to update table");
        throw err;
    }
}
//# sourceMappingURL=stSuiEventsCache.js.map